



























import { Component, Vue, Watch } from "vue-property-decorator";
import YcHeader from "@/components/common/yc-header.vue";
import YcAside from "@/components/common/yc-aside.vue";

interface paneitem {
  label: string;
  value: string;
}
const GreetingProps = Vue.extend({
  props: {
    flowDetailObj: Object
  }
})
@Component({
  components: {
    "yc-aside": YcAside,
    "yc-header": YcHeader,
  },
})
export default class wheelOfFortuneList extends GreetingProps {
  public flowDetail: {label:string,value:string,count?:number}[] = [];

  created(): void {
    this.flowDetail = this.$route.query.strategyChannel === 'Sms'? [
      {label :this.$t('views.process.detailed.text_8fdb51656570') as string,value :'-'},
      {label :this.$t('views.process.detailed.text_8fc76ee46570') as string,value :'-'},
      {label :this.$t('views.process.detailed.text_7b495f856570') as string,value :'-'},
      {label :this.$t('views.campaign.detailed.text_5df253d19001') as string,value :'-'},
      {label :this.$t('views.process.detailed.text_90018fbe7387') as string,value :'-',count:0},
      {label :this.$t('views.process.detailed.text_70b951fb7387') as string,value :'-',count:0},
      {label :this.$t('views.process.detailed.text_676581ea8ba25355') as string,value :'-'},
      {label :this.$t('views.process.detailed.text_676581ea9500552e') as string,value :'-'},
      {label :this.$t('views.process.detailed.text_8f6c53167387') as string,value :'-'},
      {label :this.$t('views.process.detailed.text_5ba253554ef7') as string,value :'-'},
      {label :this.$t('views.process.detailed.text_900056de7387') as string,value :'-',count:0},
      {label :this.$t('views.process.detailed.text_90008ba27387') as string,value :'-',count:0},
    ]:[
      {label :this.$t('views.process.detailed.text_8fdb51656570') as string,value :'-'},
      {label :this.$t('views.process.detailed.text_8fc76ee46570') as string,value :'-'},
      {label :this.$t('views.process.detailed.text_7b495f856570') as string,value :'-'},
      {label :this.$t('views.campaign.detailed.text_5df253d19001') as string,value :'-'},
      {label :this.$t('views.process.detailed.text_90018fbe7387') as string,value :'-',count:0},
      {label :this.$t('views.process.detailed.text_62535f007387') as string,value :'-',count:0},
      {label :this.$t('views.process.detailed.text_70b951fb7387') as string,value :'-',count:0},
      {label :this.$t('views.process.detailed.text_676581ea8ba25355') as string,value :'-'},
      {label :this.$t('views.process.detailed.text_676581ea9500552e') as string,value :'-'},
      {label :this.$t('views.process.detailed.text_8f6c53167387') as string,value :'-'},
      {label :this.$t('views.process.detailed.text_5ba253554ef7') as string,value :'-'},
      {label :this.$t('views.process.detailed.text_900056de7387') as string,value :'-',count:0},
      {label :this.$t('views.process.detailed.text_62958bc97387') as string,value :'-',count:0},
      {label :this.$t('views.process.detailed.text_90008ba27387') as string,value :'-',count:0},
    ]
    // this.getWheelOfFortuneList();
  }

  getclass(scope:any){return '__status--' + { 0:'suspend',1 :'running'}[scope.row.status as 1 | 0]}

  //显示空值
  formatterChangeNUll(r:any, c:any, v:any){return  v === 0?'$0':(`$${v}` || '-')}

  formatterChange(r:any, c:any, v:any) {return v === 0?0:(v || '-')}

  sortChange(){}
  @Watch("flowDetailObj")
  changFlowDetailObj(oldval: any, newval: any){
    newval = this.$props.flowDetailObj
    if (this.$route.query.strategyChannel === 'Sms') {
      this.flowDetail = [
        {label :this.$t('views.process.detailed.text_8fdb51656570') as string,value :newval.enterCount},
        {label :this.$t('views.process.detailed.text_8fc76ee46570') as string,value :newval.filterCount},
        {label :this.$t('views.process.detailed.text_7b495f856570') as string,value :newval.waitCount},
        {label :this.$t('views.campaign.detailed.text_5df253d19001') as string,value :newval.sendCount},
        {label :this.$t('views.process.detailed.text_90018fbe7387') as string,value :newval.deliveryRate,count:newval.deliveryCount},
        {label :this.$t('views.process.detailed.text_70b951fb7387') as string,value :newval.clickRate ,count:newval.clickCount},
        {label :this.$t('views.process.detailed.text_676581ea8ba25355') as string,value :newval.totalOrderCount },
        {label :this.$t('views.process.detailed.text_676581ea9500552e') as string,value :newval.totalOrderAmount },
        {label :this.$t('views.process.detailed.text_8f6c53167387') as string,value : newval.convertRate },
        {label :this.$t('views.process.detailed.text_5ba253554ef7') as string,value : newval.singlePrice},
        {label :this.$t('views.process.detailed.text_900056de7387') as string,value :newval.bounceRate ,count:newval.bounceCount},
        {label :this.$t('views.process.detailed.text_90008ba27387') as string,value :newval.unsubscribeRate ,count:newval.unsubscribeCount},
      ]
    } else {
      this.flowDetail = [
        {label :this.$t('views.process.detailed.text_8fdb51656570') as string,value :newval.enterCount},
        {label :this.$t('views.process.detailed.text_8fc76ee46570') as string,value :newval.filterCount},
        {label :this.$t('views.process.detailed.text_7b495f856570') as string,value :newval.waitCount},
        {label :this.$t('views.campaign.detailed.text_5df253d19001') as string,value :newval.sendCount},
        {label :this.$t('views.process.detailed.text_90018fbe7387') as string,value :newval.deliveryRate,count:newval.deliveryCount},
        {label :this.$t('views.process.detailed.text_62535f007387') as string,value :newval.openRate ,count:newval.openCount},
        {label :this.$t('views.process.detailed.text_70b951fb7387') as string,value :newval.clickRate ,count:newval.clickCount},
        {label :this.$t('views.process.detailed.text_676581ea8ba25355') as string,value :newval.totalOrderCount },
        {label :this.$t('views.process.detailed.text_676581ea9500552e') as string,value :newval.totalOrderAmount },
        {label :this.$t('views.process.detailed.text_8f6c53167387') as string,value : newval.convertRate },
        {label :this.$t('views.process.detailed.text_5ba253554ef7') as string,value : newval.singlePrice},
        {label :this.$t('views.process.detailed.text_900056de7387') as string,value :newval.bounceRate ,count:newval.bounceCount},
        {label :this.$t('views.process.detailed.text_62958bc97387') as string,value :newval.complaintRate ,count:newval.complaintCount},
        {label :this.$t('views.process.detailed.text_90008ba27387') as string,value :newval.unsubscribeRate ,count:newval.unsubscribeCount},
      ]
    }

  }
}
